<template>
  <section
    class="proposal-comments"
    :style="style"
  >
    <div class="proposal-comments-list">
      <comments-list :comments="proposalComments.list" />
    </div>

    <comments-composer
      ref="composer"
      v-model="content"
      :field="field"
      :processing="proposalComments.create.loading"
      class="proposal-comments-composer"
      @submit="submit"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import scrollHelper from '@/helpers/views/scroll';

  import { input } from '@/_CRUDL/helpers/form/fields';

  import CommentsList from '@/components/Comments/List.vue';
  import CommentsComposer from '@/components/Comments/Composer.vue';

  export default {
    name: 'ProposalsReadComments',
    components: {
      CommentsList,
      CommentsComposer,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        content: '',

        height: 0,
        padding: 0,
      };
    },
    computed: {
      ...mapState([
        'proposalComments',
      ]),
      id() {
        return this.$route.params.id;
      },
      field() {
        return {
          ...input,
          id: 'comment-content',
          placeholder: 'Escrever comentário...',
        };
      },
      style() {
        const styles = {};

        if (this.padding) {
          styles.paddingBottom = `${this.padding}px`;
        }

        if (this.height) {
          styles.minHeight = `calc(${this.height}px - 11em)`;
        }

        return styles;
      },
    },
    updated() {
      this.pad();
    },
    mounted() {
      this.$store.dispatch('proposalComments/list', {
        proposal_id: this.id,
        per_page: 9999,
      }).then(this.bottom);

      this.$nextTick(this.pad);
      this.$nextTick(this.size);
    },
    methods: {
      submit() {
        this.$store
          .dispatch('proposalComments/create', {
            proposal_id: this.id,
            comment: {
              content: this.content,
            },
          })
          .then(this.reset)
          .then(this.bottom);
      },
      reset() {
        this.content = '';
      },
      pad() {
        let padding = 0;

        try {
          padding = this.$refs.composer.$el.offsetHeight;
        } catch (err) { /* */ }

        if (padding && padding !== this.padding) {
          this.padding = padding;
        }

        this.bottom();
      },
      size() {
        try {
          this.height = document.querySelector('.sidebar, .app-sidebar').offsetHeight;
        } catch (err) { /* */ }
      },
      bottom() {
        this.$nextTick(this.scroll);
      },
      scroll() {
        scrollHelper(99999);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .proposal-comments {
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0;
    padding-bottom: $button;
    position: relative;
  }

  .proposal-comments-list {
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
  }

  .proposal-comments-composer {
    left: 0;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
</style>
